export function seprateNumberFromComma(num) {
  if (!num) return "-";
  let number = parseInt(num);
  let str = number.toString();

  if (str.length >= 4) {
    str = str.replace(/(\d)(?=(\d{3})+$)/g, "$1,");
  }
  return str;
}

export function seprateNumberFromCommaForInput(num) {
  if (!num) return "0";
  let number = parseInt(num);
  let str = number.toString();

  if (str.length >= 4) {
    str = str.replace(/(\d)(?=(\d{3})+$)/g, "$1,");
  }
  return str;
}

export function sepratePriceFromComma(num) {
  if (num === 0) {
    return "0";
  }
  if (!num) {
    return " - ";
  }
  let str = num.toString().split(".");
  let str2 = null;
  let res = "";

  if (str[0].length >= 4) {
    str[0] = str[0].replace(/(\d)(?=(\d{3})+$)/g, "$1,");
  }
  if (str[1]) {
    if (str[1].length < 2) {
      str2 = str[1];
    } else {
      str2 = str[1].slice(0, 2);
    }
  }
  res = str2 ? `${str[0]}.${str2}` : str[0];
  return res;
}

export function formatNumber(number) {
  if (!number) {
    return " - ";
  }
  let formattedNumber = parseInt(number).toLocaleString("en-US");

  formattedNumber = formattedNumber.split(".")[0];

  return formattedNumber;
}

const numberWithCommas = (number) => {
  if (!number) {
    return "";
  }
  return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};

export { numberWithCommas };
export function calculateMillionToman(num) {
  if (!num) {
    return "- میلیون تومان";
  }

  const millionRial = (num / 10).toFixed(0) + " میلیون تومان";

  const result = numberWithCommas(millionRial);

  return result;
}

// Example usage:
